import React from 'react';

function LinkWidget(props) {
    var _props$schema = props.schema,
        title = _props$schema.title,
        path = _props$schema.path;


    return React.createElement(
        "a",
        {
            href: path,
            target: "_blank"
        },
        title
    );
}

export default LinkWidget;